import APIAccessor from "../apiProcessor";
import { MEDKIT_API_URL } from "constants/index";

class MedkitService {
    protected api: APIAccessor;

    constructor() {
        this.api = new APIAccessor(MEDKIT_API_URL);
    }
}

export default MedkitService;
